import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/movie/${movie.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 hover:bg-background-100 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={movie.cover}
          alt={movie.title}
          title={`${movie.title} - 被窝网电影高清在线观看`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute top-2 left-2">
          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-medium bg-primary-500 text-background-50">
            <i className="ri-star-fill text-[10px]" />
            {movie.rating}
          </span>
        </div>
        {movie.isNew && (
          <div className="absolute top-2 right-2">
            <span className="inline-flex px-2 py-0.5 rounded-md text-xs font-medium bg-accent-500 text-background-50 whitespace-nowrap">
              新上线
            </span>
          </div>
        )}
        {movie.type === 'tv' && (
          <div className="absolute bottom-2 right-2">
            <span className="inline-flex px-2 py-0.5 rounded-md text-xs font-medium bg-background-900/70 text-background-100 whitespace-nowrap backdrop-blur-sm">
              {movie.episodes}集
            </span>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      </div>

      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="text-xs text-foreground-500">{movie.year}</span>
          <span className="text-xs text-foreground-400">·</span>
          <span className="text-xs text-foreground-500">{movie.category}</span>
        </div>
        {movie.tags && movie.tags.length > 0 && (
          <div className="flex flex-wrap gap-1 mt-2">
            {movie.tags.slice(0, 2).map((tag) => (
              <span
                key={tag}
                className="inline-flex px-1.5 py-0.5 rounded text-[10px] bg-background-200 text-foreground-600 whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
}